import script from "./EditShopCategoryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditShopCategoryDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditShopCategoryDialog.vue?vue&type=style&index=0&id=4c6010ea&lang=css"

const __exports__ = script;

export default __exports__